module.exports = __webpack_public_path__ + "img/seo-mobile.54006960.jpg";